<template>
    <div class="tab-general-info">
        <div class="smalltitle blockcont">General Information</div>
        <div class="blockcont">
            <form>
                <div class="prolabel">Group Name</div>
                <div class="profield">
                    <input type="text" v-model="generalInfo.name" maxlength="100"
                           :disabled="disabledForm">
                </div>
                <div class="prolabel">Phone</div>
                <div class="profield">
                    <input type="text" v-model="generalInfo.phone" maxlength="100"
                           :disabled="disabledForm">
                </div>

                <div class="prolabel">Introduction</div>
                <div class="profield">
                    <div style="border: 1px solid #e1e1e1;padding: 8px 10px;background: #efefef;" v-html="generalInfo.introdution" :disabled="disabledForm"></div>
                </div>

                <div class="prolabel">Website</div>
                <div class="profield">
                    <input type="text" v-model="generalInfo.website" maxlength="100" :disabled="disabledForm">
                </div>
                <div class="prolabel">Goals / Missions</div>
                <div class="profield">
                    <div style="border: 1px solid #e1e1e1;padding: 8px 10px;background: #efefef;" v-html="generalInfo.missions" :disabled="disabledForm"></div>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
import config from '../../../../config'

export default {
  name: 'TabGeneralInfo',
  components: {},
  props: {
    userInfo: {},
    profile: {},
    disabledForm: {}
  },
  mixins: [],
  data () {
    return {
      generalInfo: {}
    }
  },
  computed: {},
  watch: {},
  updated () {
  },
  mounted () {
    if (this.profile) {
      this.generalInfo.name = this.profile.name
      this.generalInfo.phone = this.profile.phone
      this.generalInfo.introdution = this.profile.introdution
      this.generalInfo.website = this.profile.website
      this.generalInfo.missions = this.profile.missions
    }
    this.$forceUpdate()
  },
  beforeDestroy () {
  },
  methods: {}
}
</script>
<style scoped="">

</style>
